import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import ConfigurationManagement from './config/views/ConfigurationManagement';
import SubscriptionManagement from './config/views/SubscriptionManagement';
import { RequestManagement } from './runtime/views/RequestManagement';
import { RequestHistoryView } from './runtime/views/RequestHistoryView';
import { MyPendingRequestsView } from './runtime/views/MyPendingRequestsView';
import { MyRequestsView } from './runtime/views/MyRequestsView';
import WorkflowEditor from './config/components/editor/WorkflowEditor';
import { ReactFlowProvider } from 'reactflow';
import { App } from 'antd';
import DynamicFormConfigEditor from './config/components/editor/DynamicFormConfigEditor';
import ActionFlowApprovalView from './runtime/components/requests/ActionFlowApprovalView';

export const actionFlowRoutes: RouteObject[] = [
    {
        path: '/admin/action-flow/configurations',
        element: <ConfigurationManagement />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/action-flow/subscriptions',
        element: <SubscriptionManagement />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/action-flow/subscriptions/:domain/:subscriptionId/config',
        element: <DynamicFormConfigEditor />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/requests/pending',
        element: <RequestManagement />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/requests/history',
        element: <RequestHistoryView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/requests/my-pending',
        element: <MyPendingRequestsView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/requests/my-requests',
        element: <MyRequestsView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/requests/approval/:scopeId',
        element: <ReactFlowProvider><ActionFlowApprovalView /></ReactFlowProvider>,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/action-flow/configurations/new',
        element: <App><ReactFlowProvider><WorkflowEditor /></ReactFlowProvider></App>,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/action-flow/configurations/:id',
        element: <App><ReactFlowProvider><WorkflowEditor /></ReactFlowProvider></App>,
        errorElement: <ErrorBoundary />
    },
];